import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f68cb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9"
}
const _hoisted_2 = {
  id: "has-access-to-table",
  "aria-label": "oversigt rådgiver som har adgang",
  class: "table w-percent-100"
}
const _hoisted_3 = {
  key: 0,
  class: "bg-primary text-color-white"
}
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["id"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_10 = ["data-cy-id"]
const _hoisted_11 = {
  "data-title": "Cvr",
  style: {"width":"10%"}
}
const _hoisted_12 = {
  "data-title": "CompanyName",
  style: {"width":"25%"}
}
const _hoisted_13 = {
  key: 0,
  id: "access-request-notification-wrapper",
  class: "flex-column"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#reply" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "access-action-pending" }
const _hoisted_18 = { style: {"width":"25%","word-break":"break-word"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  key: 0,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_21 = {
  key: 1,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_22 = {
  "data-title": "Calculations",
  style: {"width":"35%"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "tab"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "tab"
}
const _hoisted_28 = { "data-title": "Handlinger" }
const _hoisted_29 = { class: "overflow-menu overflow-menu--open-left" }
const _hoisted_30 = ["data-js-target"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  fill: "white",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#more-vert" })
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["id"]
const _hoisted_34 = { class: "overflow-list" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#how-to-reg" })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = {
  key: 1,
  id: "no-calculation-added-message",
  class: "container px-0 py-9"
}
const _hoisted_41 = {
  key: 2,
  class: "container px-0 py-9"
}
const _hoisted_42 = {
  id: "expired-table",
  "aria-label": "oversigt rådgiver som har adgang",
  class: "table w-percent-100"
}
const _hoisted_43 = {
  key: 0,
  class: "bg-primary text-color-white"
}
const _hoisted_44 = ["id", "onClick"]
const _hoisted_45 = {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_46 = ["fill"]
const _hoisted_47 = ["fill"]
const _hoisted_48 = ["id"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_50 = {
  "data-title": "Cvr",
  style: {"width":"10%"}
}
const _hoisted_51 = {
  "data-title": "CompanyName",
  style: {"width":"25%"}
}
const _hoisted_52 = { style: {"width":"25%","word-break":"break-word"} }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = {
  key: 0,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = {
  key: 0,
  class: "badge badge-small"
}
const _hoisted_57 = {
  key: 1,
  class: "badge badge-small"
}
const _hoisted_58 = {
  key: 1,
  "data-title": "EndData",
  style: {"width":"10%"}
}
const _hoisted_59 = {
  key: 0,
  class: "badge badge-small"
}
const _hoisted_60 = {
  "data-title": "Calculations",
  style: {"width":"35%"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = {
  key: 0,
  class: "tab"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = {
  key: 0,
  class: "tab"
}
const _hoisted_66 = { "data-title": "Handlinger" }
const _hoisted_67 = { class: "overflow-menu overflow-menu--open-left" }
const _hoisted_68 = ["data-js-target"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  fill: "white",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#more-vert" })
], -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = ["id"]
const _hoisted_72 = { class: "overflow-list" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = { class: "modal-body" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_83 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_84 = {
  class: "modal-content",
  style: {"max-width":"1000px"}
}
const _hoisted_85 = { class: "modal-header" }
const _hoisted_86 = { id: "modal-description-wrapper" }
const _hoisted_87 = {
  class: "modal-title",
  id: "access-request-modal-heading"
}
const _hoisted_88 = { id: "access-request-modal-description" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "modal-body" }
const _hoisted_92 = { class: "col-10 form-group-acceses" }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-minus" }, null, -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = {
  key: 1,
  class: "icon-container"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-plus" }, null, -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { class: "access-heading mb-4" }
const _hoisted_101 = { class: "individuals-container" }
const _hoisted_102 = { class: "row-6 full-width pb-4" }
const _hoisted_103 = ["id", "data-cy-id"]
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = { key: 1 }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = { key: 2 }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_111 = { key: 3 }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_113 = ["onClick"]
const _hoisted_114 = ["onClick"]
const _hoisted_115 = ["onClick"]
const _hoisted_116 = { class: "modal-footer" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AcceptModal = _resolveComponent("AcceptModal")!
  const _component_simple_text = _resolveComponent("simple-text")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, { tabMenu: _ctx.menu }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.headerTitle" })
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.headerText" })
        ])
      ]),
      _: 1
    }, 8, ["tabMenu"]),
    (_ctx.accesses.some(x=>(x.expireDate>_ctx.currentDate && !x.revoked) || (!x.expireDate && !x.revoked)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, [
            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.headerList" })
          ]),
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              (_ctx.tableHeaders)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (tableHeader) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              style: {"width":"5%"},
                              id: `table-header-${tableHeader.id}-${_ctx.id}`,
                              key: tableHeader.sortKey,
                              class: "clickable",
                              scope: "col",
                              onClick: ($event: any) => (_ctx.sort(tableHeader.sortKey))
                            }, [
                              _createTextVNode(_toDisplayString(tableHeader.headline) + " ", 1),
                              (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'asc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M9.99419 4.75003L6.00003 0.755859L2.00586 4.75003H9.99419Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_6),
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'desc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M2.00586 7.25003L6.00003 11.2442L9.99419 7.25003H2.00586Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_7)
                              ]))
                            ], 8, _hoisted_4))
                          : _createCommentVNode("", true),
                        (!tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              id: `table-header-${tableHeader.id}-${_ctx.id}`,
                              key: tableHeader.id,
                              class: "clickable",
                              scope: "col"
                            }, _toDisplayString(tableHeader.headline), 9, _hoisted_8))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256)),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAccesses.filter(x=>(x.expireDate>_ctx.currentDate && !x.revoked) || (!x.expireDate && !x.revoked)), (acc) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: acc.id,
                  "data-cy-id": acc.vatId
                }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(acc.vatId), 1),
                  _createElementVNode("td", _hoisted_12, [
                    _createTextVNode(_toDisplayString(acc.companyName) + " ", 1),
                    (_ctx.hasPendingRequestAccess(acc))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", {
                            class: "access-actions-container clickable-container",
                            onClick: ($event: any) => (_ctx.accessRequestModal(acc))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'icon-svg': !_ctx.iconToggle, 'icon-svg-2': _ctx.iconToggle })
                            }, _hoisted_16, 2),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(this.getContentfulString('thirdparty.step2.notification.access-actions-pending')), 1)
                          ], 8, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createTextVNode(_toDisplayString(acc.contantPersonName) + " ", 1),
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(acc.contactPersonEmail), 1)
                  ]),
                  (acc.expireDate)
                    ? _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_20, null, 512)), [
                        [_directive_dompurify_html, _ctx.formatDate(acc.expireDate)]
                      ])
                    : (_openBlock(), _createElementBlock("td", _hoisted_21)),
                  _createElementVNode("td", _hoisted_22, [
                    (_ctx.hasDraft(acc))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.draft" })
                          ]),
                          _createTextVNode(),
                          _hoisted_23
                        ], 64))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_ctx.hasCompleted(acc))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_25, [
                          _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.completed" })
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(),
                    _hoisted_26,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (!calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("button", {
                        class: _normalizeClass([`overflow-menu-table`, "button-overflow-menu js-dropdown"]),
                        "data-js-target": `access-${acc.id}-actions-overflow`,
                        "aria-expanded": "false",
                        "aria-haspopup": "true",
                        "aria-label": "handlinger"
                      }, _hoisted_32, 8, _hoisted_30),
                      _createElementVNode("div", {
                        id: `access-${acc.id}-actions-overflow`,
                        "aria-hidden": "true",
                        class: "overflow-menu-inner"
                      }, [
                        _createElementVNode("ul", _hoisted_34, [
                          _createElementVNode("li", null, [
                            _createVNode(_component_router_link, {
                              class: _normalizeClass(_ctx.hasPendingRequestAccess(acc) ? 'request-pending edit-button' : 'edit-button'),
                              to: "",
                              onClick: ($event: any) => (_ctx.accessRequestModal(acc))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.access-request-modal-menu-button" }),
                                _hoisted_35
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"])
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_router_link, {
                              class: "edit-button",
                              to: "/setup/access/edit-access",
                              onClick: ($event: any) => (_ctx.editAccess(acc))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.edit" }),
                                _hoisted_36
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "delete-button",
                              onClick: ($event: any) => (_ctx.confirmDeleteAccess(acc))
                            }, [
                              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.delete" }),
                              _hoisted_38
                            ], 8, _hoisted_37)
                          ])
                        ])
                      ], 8, _hoisted_33)
                    ])
                  ])
                ], 8, _hoisted_10))
              }), 128))
            ])
          ]),
          _hoisted_39,
          _createVNode(_component_router_link, {
            "data-cy-id": "opret-adgang",
            class: "button button-primary mr-4",
            to: "/setup/access/create-access",
            onClick: _ctx.createAccess
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.titleAdd" })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("p", null, [
            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.noCalculationsAdded" })
          ]),
          _createVNode(_component_router_link, {
            "data-cy-id": "opret-adgang",
            class: "button button-primary mr-4",
            to: "/setup/access/create-access",
            onClick: _ctx.createAccess
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.titleAdd" })
            ]),
            _: 1
          }, 8, ["onClick"])
        ])),
    (_ctx.accesses.some(x=>x.expireDate<=_ctx.currentDate || x.revoked))
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("h1", null, [
            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.expiredAccessTableHeader" })
          ]),
          _createElementVNode("table", _hoisted_42, [
            _createElementVNode("thead", null, [
              (_ctx.tableHeaders)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (tableHeader) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              style: {"width":"5%"},
                              id: `table-header-${tableHeader.id}-${_ctx.id}`,
                              key: tableHeader.sortKey,
                              class: "clickable",
                              scope: "col",
                              onClick: ($event: any) => (_ctx.sort(tableHeader.sortKey))
                            }, [
                              _createTextVNode(_toDisplayString(tableHeader.headline) + " ", 1),
                              (_openBlock(), _createElementBlock("svg", _hoisted_45, [
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'asc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M9.99419 4.75003L6.00003 0.755859L2.00586 4.75003H9.99419Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_46),
                                _createElementVNode("path", {
                                  fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDirection === 'desc' ? 'white' : '',
                                  "clip-rule": "evenodd",
                                  d: "M2.00586 7.25003L6.00003 11.2442L9.99419 7.25003H2.00586Z",
                                  "fill-rule": "evenodd",
                                  stroke: "white"
                                }, null, 8, _hoisted_47)
                              ]))
                            ], 8, _hoisted_44))
                          : _createCommentVNode("", true),
                        (!tableHeader.sortKey)
                          ? (_openBlock(), _createElementBlock("th", {
                              id: `table-header-${tableHeader.id}-${_ctx.id}`,
                              key: tableHeader.id,
                              class: "clickable",
                              scope: "col"
                            }, _toDisplayString(tableHeader.headline), 9, _hoisted_48))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256)),
                    _hoisted_49
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAccesses.filter(x=>x.expireDate<=_ctx.currentDate || x.revoked), (acc) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: acc.id
                }, [
                  _createElementVNode("td", _hoisted_50, _toDisplayString(acc.vatId), 1),
                  _createElementVNode("td", _hoisted_51, [
                    _createTextVNode(_toDisplayString(acc.companyName) + " ", 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(acc.revoked ? this.thirdPartyRequestRejected + ' ' + _ctx.formatDate(acc.revokedDate) : ''), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_52, [
                    _createTextVNode(_toDisplayString(acc.contantPersonName) + " ", 1),
                    _hoisted_53,
                    _createTextVNode(" " + _toDisplayString(acc.contactPersonEmail), 1)
                  ]),
                  (acc.expireDate)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(acc.expireDate)) + " ", 1),
                        _hoisted_55,
                        (acc.expireDate<=_ctx.currentDate)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.expiredTag" })
                            ]))
                          : _createCommentVNode("", true),
                        (acc.revoked)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.rejectedTag" })
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_58, [
                        (acc.revoked)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.rejectedTag" })
                            ]))
                          : _createCommentVNode("", true)
                      ])),
                  _createElementVNode("td", _hoisted_60, [
                    (_ctx.hasDraft(acc))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.draft" })
                          ]),
                          _createTextVNode(),
                          _hoisted_61
                        ], 64))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_ctx.hasCompleted(acc))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_63, [
                          _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.completed" })
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(),
                    _hoisted_64,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.calculationInfoList, (calc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: calc.calculationId
                      }, [
                        (!calc.isKladde)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(`${calc.calculationName}`), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("button", {
                        class: _normalizeClass([`overflow-menu-table`, "button-overflow-menu js-dropdown"]),
                        "data-js-target": `access-${acc.id}-actions-overflow`,
                        "aria-expanded": "false",
                        "aria-haspopup": "true",
                        "aria-label": "handlinger"
                      }, _hoisted_70, 8, _hoisted_68),
                      _createElementVNode("div", {
                        id: `access-${acc.id}-actions-overflow`,
                        "aria-hidden": "true",
                        class: "overflow-menu-inner"
                      }, [
                        _createElementVNode("ul", _hoisted_72, [
                          (!acc.revoked)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_73, [
                                _createVNode(_component_router_link, {
                                  class: "edit-button",
                                  to: "/setup/access/edit-access",
                                  onClick: ($event: any) => (_ctx.editAccess(acc))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.edit" }),
                                    _hoisted_74
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "delete-button",
                              onClick: ($event: any) => (_ctx.confirmDeleteAccess(acc))
                            }, [
                              _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.delete" }),
                              _hoisted_76
                            ], 8, _hoisted_75)
                          ])
                        ])
                      ], 8, _hoisted_71)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _hoisted_77
        ]))
      : _createCommentVNode("", true),
    (_ctx.accessToDelete.id && _ctx.accessToDelete.id > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 3,
          "value-object": _ctx.accessToDelete,
          "title-key": 'thirdparty.has-access-to.delete-modal.title',
          "buttons-disabled": _ctx.disableDeleteModalButtons,
          "button-ok-text-key": 'thirdparty.has-access-to.delete-modal.button.ok',
          "button-reject-text-key": 'thirdparty.has-access-to.delete-modal.button.cancel',
          onSelectOk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteAccess($event))),
          onSelectReject: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetAccessToDelete()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_SimpleText, { "text-key": 'thirdparty.has-access-to.delete-modal.text1' }, null, 8, ["text-key"])
                ]),
                _hoisted_79,
                _hoisted_80,
                _createTextVNode(_toDisplayString(_ctx.accessToDelete.companyName) + " (CVR=" + _toDisplayString(_ctx.accessToDelete.vatId) + ")", 1),
                _hoisted_81,
                _hoisted_82,
                _createVNode(_component_SimpleText, { "text-key": 'thirdparty.has-access-to.delete-modal.text2' }, null, 8, ["text-key"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true),
    (_ctx.showHandleAccessRequestModal)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("h2", _hoisted_87, [
                    _createVNode(_component_SimpleText, { "text-key": "thirdparty.access.handle-access-request-heading" })
                  ]),
                  _withDirectives(_createElementVNode("p", _hoisted_88, null, 512), [
                    [_directive_dompurify_html, _ctx.documentToHtmlString(_ctx.changeAccessRequestModalDescription)]
                  ])
                ]),
                _createElementVNode("button", {
                  "aria-label": "Luk",
                  class: "modal-close button button-unstyled",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelHandleAccessRequest()))
                }, _hoisted_90)
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("h3", null, [
                  _createVNode(_component_simple_text, { "text-key": "thirdparty.access.handle-access-modal-header" })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAccesses.filter(x => (x.expireDate > _ctx.currentDate && !x.revoked) || (!x.expireDate && !x.revoked)), (access, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: access.id
                  }, [
                    _createElementVNode("div", {
                      class: "row change-access-item pt-3",
                      style: _normalizeStyle({'border-bottom': index !== _ctx.accessInfos.length - 1 ? '1px solid #ccc' : 'none' })
                    }, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", {
                          class: "button-unstyled",
                          onClick: ($event: any) => (_ctx.toggleAccordion(index))
                        }, [
                          (_ctx.activeAccordion === index)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_94, _hoisted_96))
                            : (_openBlock(), _createElementBlock("span", _hoisted_97, _hoisted_99)),
                          _createElementVNode("h4", _hoisted_100, _toDisplayString(access.companyName) + " | " + _toDisplayString(this.getContentfulString('thirdparty.access-request-modal-cvr.text') + '') + " " + _toDisplayString(access.vatId), 1)
                        ], 8, _hoisted_93)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(access.individualsAccessInfoList, (individual) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "individual-item",
                              key: individual.id,
                              id: 'individual-access-request-' + individual.id,
                              "data-cy-id": individual.id
                            }, [
                              (individual.status?.toString() !== 'ACCESS_DELETED')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                    (individual.status?.toString() === 'ACCESS_PENDING' && individual.status?.toString() !== 'ACCESS_REVOKED')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_105, [
                                          _createElementVNode("strong", null, _toDisplayString(individual.name), 1),
                                          _createTextVNode(),
                                          _hoisted_106,
                                          _createTextVNode(" " + _toDisplayString(this.getContentfulString('thirdparty.access-request-modal.individual-request.text') + '') + " ", 1),
                                          _createElementVNode("strong", null, _toDisplayString(access.companyName), 1)
                                        ]))
                                      : (individual.status?.toString() === 'ACCESS_GRANTED')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_107, [
                                            _createElementVNode("strong", null, _toDisplayString(individual.name), 1),
                                            _createTextVNode(),
                                            _hoisted_108,
                                            _createTextVNode(" " + _toDisplayString(this.getContentfulString('thirdparty.access-request-modal.access-active.text')), 1)
                                          ]))
                                        : (individual.status?.toString() === 'ACCESS_REJECTED')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_109, [
                                              _createElementVNode("strong", null, _toDisplayString(individual.name), 1),
                                              _createTextVNode(),
                                              _hoisted_110,
                                              _createTextVNode(" " + _toDisplayString(this.getContentfulString('thirdparty.access-request-modal.access-rejected.text')), 1)
                                            ]))
                                          : (individual.status?.toString() === 'ACCESS_REVOKED')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_111, [
                                                _createElementVNode("strong", null, _toDisplayString(individual.name), 1),
                                                _createTextVNode(),
                                                _hoisted_112,
                                                _createTextVNode(" " + _toDisplayString(this.getContentfulString('thirdparty.access-request-modal.access-revoked.text')), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                    (individual.status?.toString() === 'ACCESS_PENDING')
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 4,
                                          class: "button button-primary",
                                          onClick: ($event: any) => (_ctx.grantIndividualAccess(individual.id))
                                        }, _toDisplayString(this.getContentfulString('menu.setupmenu.item.access')), 9, _hoisted_113))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      class: "button button-secondary",
                                      onClick: ($event: any) => (_ctx.deleteIndividualAccess(individual.id))
                                    }, _toDisplayString(this.getContentfulString('access.remove-access')), 9, _hoisted_114),
                                    (individual.status?.toString() !== 'ACCESS_REVOKED' && individual.status?.toString() === 'ACCESS_PENDING')
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 5,
                                          class: "button button-secondary",
                                          onClick: ($event: any) => (_ctx.rejectIndividualAccess(individual.id))
                                        }, _toDisplayString(this.getContentfulString('thirdparty.access-request-modal.reject-button.text')), 9, _hoisted_115))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_103))
                          }), 128))
                        ])
                      ], 512), [
                        [_vShow, _ctx.activeAccordion === index]
                      ])
                    ], 4)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("button", {
                  class: "button button-secondary",
                  "data-cy-id": "modal-cancel",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelHandleAccessRequest()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "thirdparty.access-request-modal.finish-button" })
                ])
              ])
            ])
          ]),
          _hoisted_117
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}